// 权限组件
import React, { useContext } from 'react';
import { StudioContext } from '@home/pages/studio/context';
import StudioState from '../StudioState';

interface Iprops {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const CommonPermissionWrap = (props: Iprops) => {
  const { className, style, children } = props;
  const { menuPermission } = useContext(StudioContext);

  return (
    <div className={className} style={style} >
      {
        menuPermission === false ? <StudioState isNoPermission={true} /> : children
      }
    </div>
  );
};

export default CommonPermissionWrap;
